<template>
    <transition name="modal" v-if="isActive">
        <div class="modal-mask">
            <div class="modal-confirm-payment modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            {{ $PPlusEngine.getDictionary($route.params.lang, 'ส่งหลักฐานการโอนเงิน', 'Submit for Transfer Slip') }}
                            <button @click="hideConfirmPayment()"><font-awesome-icon :icon="['fas', 'times']" /></button>
                        </h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'เลือกภาษาของคอร์ส', 'Course Language') }}</label>
                            <div class="input-radio">
                                <div class="radio-inline" v-for="(item, index) in courseOption" :key="index">
                                    <input type="radio" :value="item.value" v-model="confirmPaymentForm.courseLanguage">
                                    <label>{{ item.text }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'สลิปหลักฐานการโอน', 'Transfer Slip') }} (File: jpg/png)</label>
                            <we-single-upload 
                                v-model="confirmPaymentForm.file" 
                                :classWrapper="'upload-file' + (confirmPaymentValidate.file.invalid ? ' upload-error' : '')"
                                classError="error-message"
                                :placeholder="$PPlusEngine.getDictionary($route.params.lang, 'โปรดเลือกไฟล์', 'Browse File')" 
                                :fileTypeErrorText="$PPlusEngine.getDictionary($route.params.lang, 'โปรดเลือกไฟล์ประเภท JPG หรือ PNG เท่านั้น', 'Allow only JPG or PNG')"
                                :fileTypeAllow="['image/jpeg', 'image/png']"
                                :fileSizeErrorText="$PPlusEngine.getDictionary($route.params.lang, 'โปรดอัพโหลดไฟล์ขนาดไม่เกิน 1MB', 'File size must be less than 1MB')"
                                :fileSizeAllow=1048576 />
                            <span class="error-message" v-if="confirmPaymentValidate.file.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้เลือกไฟล์หลักฐานการโอน', 'Please add your slip transfer') }}</span>
                        </div>
                        <div class="form-group">
                            <b-form-checkbox
                                v-model="confirmPaymentForm.taxRequest"
                                value="yes"
                                unchecked-value="no"
                            >
                                {{ $PPlusEngine.getDictionary($route.params.lang, 'ต้องการใบเสร็จ', 'Request for Receipt') }}
                            </b-form-checkbox>
                        </div>
                        <template v-if="confirmPaymentForm.taxRequest == 'yes'">
                            <div class="form-group">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อ/ชื่อบริษัท', 'Name/Company') }}</label>
                                <input type="text" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(confirmPaymentValidate.taxName.invalid)" v-model="confirmPaymentForm.taxName" />
                                <span class="error-message" v-if="confirmPaymentValidate.taxName.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้ระบุชื่อ/ชื่อบริษัท', 'Please input tax name/company') }}</span>
                            </div>
                            <div class="form-group">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'เลขบัตรประชาชน/เลขนิติบุคคล', 'Personal ID/Corporate Number') }}</label>
                                <input type="text" class="form-control" maxlength="20" :class="$PPlusEngine.highlightInvalidField(confirmPaymentValidate.taxID.invalid)" v-model="confirmPaymentForm.taxID" />
                                <span class="error-message" v-if="confirmPaymentValidate.taxID.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้ระบุเลขบัตรประชาชน/เลขนิติบุคคล', 'Please input personal id/corporate number') }}</span>
                            </div>
                            <div class="form-group">
                                <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ที่อยู่ในการออกใบเสร็จ', 'Receipt Address') }}</label>
                                <input type="text" class="form-control" maxlength="100" :class="$PPlusEngine.highlightInvalidField(confirmPaymentValidate.taxAddress.invalid)" v-model="confirmPaymentForm.taxAddress" />
                                <span class="error-message" v-if="confirmPaymentValidate.taxAddress.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้ระบุที่อยู่ในการออกใบเสร็จ', 'Please input receipt address') }}</span>
                            </div>
                        </template>
                        <span class="error-message" v-if="confirmPaymentValidate.form.invalid">{{ confirmPaymentValidate.form.message }}</span>
                        <div class="action">
                            <button class="btn btn-main btn-block" @click="submitConfirm()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ส่งหลักฐาน', 'Submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    data() {
        return {
            isActive: false,
            courseOption: [
                { text: 'ภาษาไทย', value: 'th' },
                { text: 'English', value: 'en' },
            ],
            confirmPaymentForm: this.initModelConfirmPayment(),
            confirmPaymentValidate: this.initValidateConfirmPayment()
        }
    },
    props: {
        isDisplay: Boolean
    },
    watch: {
        isDisplay(value) {
            let page = this;

            setTimeout(function () {
                page.isActive = value;
            }, 50);
        },
        isActive(curr) {
            if (curr) {
                this.$WeHelper.modalScrollable(true);
            }
            else {
                this.$WeHelper.modalScrollable(false);
            }
        }
    },
    methods: {
        hideConfirmPayment() {
            this.$emit('hideConfirmPayment', null);
        },
        initModelConfirmPayment() {
            return { file: null, courseLanguage: 'th', taxRequest: 'no', taxName: '', taxID: '', taxAddress: '', langCode: this.$route.params.lang };
        },
        initValidateConfirmPayment() {
            return {
                file: { invalid: false, blank: false },
                taxName: { invalid: false, blank: false },
                taxID: { invalid: false, blank: false },
                taxAddress: { invalid: false, blank: false },
                form: { invalid: false, message: '' }
            }
        },
        submitConfirm() {
            this.confirmPaymentValidate = this.initValidateConfirmPayment();

            if (!this.validateField()) {
                let loader = this.$WeHelper.modalLoad();
                let header = this.$PPlusEngine.getHeaderToken();
                header.headers['Content-Type'] = 'multipart/form-data';
                let apiURL = this.$PPlusConfig.ApiURL;
                let formData = new FormData();

                for ( var key in this.confirmPaymentForm) {
                    formData.append(key, this.confirmPaymentForm[key]);
                }

                this.$WeHelper.postAPI(apiURL, '/api/payment/submit-confirm', formData, header).then((response) => {
                    if (!this.$WeHelper.isNullOrEmpty(response.data)) {
                        if (response.data.success) {
                            loader.hide();
                            this.$emit('hideConfirmPayment', response.data);
                        }
                        else {
                            loader.hide();
                            this.confirmPaymentValidate.form.invalid = true;
                            this.confirmPaymentValidate.form.message = response.data.message;
                        }
                    }
                    else {
                        loader.hide();
                        this.alertSystemError();
                    }
                });
            }
        },
        validateField() {
            var isError = false;

            if (this.$WeHelper.isNullOrEmpty(this.confirmPaymentForm.file)) {
                this.confirmPaymentValidate.file.invalid = true;
                this.confirmPaymentValidate.file.blank = true;
                isError = true;
            }

            if (this.confirmPaymentForm.taxRequest == 'yes') {
                if (!this.confirmPaymentForm.taxName) {
                    this.confirmPaymentValidate.taxName.invalid = true;
                    this.confirmPaymentValidate.taxName.blank = true;
                    isError = true;
                }

                if (!this.confirmPaymentForm.taxID) {
                    this.confirmPaymentValidate.taxID.invalid = true;
                    this.confirmPaymentValidate.taxID.blank = true;
                    isError = true;
                }

                if (!this.confirmPaymentForm.taxAddress) {
                    this.confirmPaymentValidate.taxAddress.invalid = true;
                    this.confirmPaymentValidate.taxAddress.blank = true;
                    isError = true;
                }
            }

            return isError;
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.modal-confirm-payment {
    label {
        color: #666;
        font-size: 14px;
        margin-bottom: 3px;
    }

    .input-radio {
        padding: 9px 15px 12px;
        border: 1px solid #ddd;

        .radio-inline {
            @include verticalAlign(middle);
            margin-right: 20px;

            input {
                @include verticalAlign(middle);
                margin: 0;
                margin-right: 5px;
            }

            label {
                @include verticalAlign(middle);
                margin: 0;
                line-height: normal;
            }
        }
    }

    .upload-file {
        .text {
            font-size: 15px;
            height: 50px;
            padding: 12px 32px 12px 15px;
            color: #495057;
            border: 1px solid #ddd;
        }
    }

    .upload-error {
        .text {
            border: 1px solid #cc0000;
        }
    }

    .action {
        padding-top: 15px;
    }
}
</style>